// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ControlUnitsPage from "../pages/ControlUnits/ControlUnits";
const __wvcRoutePaths = ["/ControlUnitsPage", "/steuergerate"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["3d-scanning-reverse-engineering", "cad-konstruktion", "cadkonstruktionpage", "contactpage", "controlunitspage", "dataprotectionpage", "datenschutz", "diagnose", "diagnosepage", "fertigung-bearbeitung", "fertigungbearbeitungpage", "homepage", "impressum", "imprintpage", "keyservicepage", "kontakt", "optimierungpage", "post", "privacypage", "reifenservice", "reifenservicepage", "scanning3dpage", "schlussel-service", "software-leistungsoptimierung", "startseite", "steuergerate"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ControlUnitsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ControlUnitsPage />} />
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
